import { OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import {
  WorkflowDesignerDispatcherAction,
  WorkflowDesignerDispatcherService
} from './workflow-designer-dispatcher.service';

export abstract class AbstractWorkflowDesignerDispatcherObserver implements OnInit, OnDestroy {

  dispatcher$: Subscription;

  constructor(protected dispatcherService: WorkflowDesignerDispatcherService) {

  }

  abstract onDispatcherEvent(action: WorkflowDesignerDispatcherAction);

  ngOnDestroy() {
    if (this.dispatcher$) {
      this.dispatcher$.unsubscribe();
      this.dispatcher$ = null;
    }
  }

  ngOnInit() {
    this.dispatcher$ = this.dispatcherService.subscribe(action => this.onDispatcherEvent(action));
  }
}



// WEBPACK FOOTER //
// ./src/library/designer/abstract-workflow-designer-dispatcher-observer.ts